import PropTypes from "prop-types";
import Divider from "common/components/partials/modal/divider";
import useI18n from "common/hooks/use-i18n";

function RequestAccommodation({back, requestAccommodation}) {
  const i18n = useI18n();

  return (
    <>
      <section>
        <p>{i18n.t("survey.accommodation.request_text")}</p>
      </section>
      <Divider />
      <section className="flex gap-2 justify-between">
        <button className="btn-outline-gray" onClick={back} title={i18n.t("back")} type="button">{i18n.t("back")}</button>
        <button className="btn-theme" onClick={requestAccommodation} title={i18n.t("survey.accommodation.request")} type="button">{i18n.t("survey.accommodation.confirm")}</button>
      </section>
    </>
  );
}

RequestAccommodation.propTypes = {
  back: PropTypes.func.isRequired,
  requestAccommodation: PropTypes.func.isRequired
};

export default RequestAccommodation;
